import React, { useCallback, useContext } from "react"
import { DataContext } from "@/contexts"
import { editSchedule } from "../../configurations/domain"
import { ScheduleFormProvider } from "../../providers/schedule_form_providers"
import { ExistingScheduleDetector } from "./existing_schedule_detector"
import { ScheduleForm } from "./form"
import { multipleValidateScheduleForm, useEditInitialValues, validateScheduleForm } from "./utils"

const EditScheduleFormContent = ({
  onSubmit,
  onCancel,
  schedules,
  totalScheduledSessions,
  loading,
  dateRangeRequired,
  canManageTranscriptions,
}) => {
  const { existingSchedule } = useContext(DataContext)

  const { initialValues, multipleValues } = useEditInitialValues(schedules)

  const submit = useCallback(data => onSubmit(data, multipleValues), [multipleValues, onSubmit])

  const validateForm =
    schedules.length > 1 ? multipleValidateScheduleForm : validateScheduleForm({ type: "edit", totalScheduledSessions })
  return (
    <ScheduleForm
      initialValues={initialValues}
      multipleValues={multipleValues}
      validate={validateForm}
      loading={loading}
      disabled={Boolean(existingSchedule)}
      type="edit"
      onSubmit={submit}
      onCancel={onCancel}
      dateRangeRequired={dateRangeRequired}
      canManageTranscriptions={canManageTranscriptions}
    >
      {schedules?.length === 1 && <ExistingScheduleDetector schedule={schedules[0]} />}
    </ScheduleForm>
  )
}

export const EditScheduleForm = props => (
  <ScheduleFormProvider configs={editSchedule}>
    <EditScheduleFormContent {...props} />
  </ScheduleFormProvider>
)
